import { QUICK_LIST_PRODUCT_CUSTOM_LIST_TYPE_ID } from '../../SearchQuickList/constants/quickList.constants'

export const QUICK_LIST_MAX_PRODUCT_QUANTITY = 999999

export const isValidProductQuantity = value => {
  const parsed = Number(value)
  return (
    Number.isInteger(parsed) &&
    parsed >= 1 &&
    parsed <= QUICK_LIST_MAX_PRODUCT_QUANTITY
  )
}

const toValidQuantity = value =>
  isValidProductQuantity(value) ? Number(value) : 1

export const buildQuickListPayload = ({ values, editMode, id, userId }) => ({
  Name: values.name,
  ProductCustomListId: editMode ? id : null,
  Description: values.description,
  ProductCustomListTypeId: QUICK_LIST_PRODUCT_CUSTOM_LIST_TYPE_ID,
  UserId: userId,
  Warehouses: values.warehouses
    .map(warehouse => warehouse.WarehouseId)
    .filter(Boolean)
    .join(','),
  Products: values.products.map(product => ({
    ProductId: product.ProductId,
    Quantity: toValidQuantity(product.Quantity),
  })),
  Status: editMode ? !!values.status : true,
})

export const mapQuickListItemToFormValues = item => ({
  name: item.Name || '',
  description: item.Description || '',
  status: !!item.Status,
  warehouses: (item.Warehouse || []).map(warehouse => ({
    WarehouseId: warehouse.WarehouseId
      ? warehouse.WarehouseId.toLowerCase()
      : null,
    Description: warehouse.Description,
  })),
  products: (item.ProductList || []).map(product => ({
    ProductId: product.ProductId ? product.ProductId.toLowerCase() : null,
    ProductName: product.ProductName,
    Sku: product.Sku,
    Images: product.Images || [],
    Quantity: product.Quantity ?? 1,
  })),
})
